/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

// Hide header on scroll down, show on scroll up
  let lastScroll = 0;
  const header = document.querySelector('[data-header-wrapper]');
  const scrollThreshold = 5;
  
  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    
    if (currentScroll <= 0) {
      header.classList.remove('header--hidden');
      return;
    }
    
    if (currentScroll > lastScroll && currentScroll > scrollThreshold) {
      header.classList.add('header--hidden');
    } else if (currentScroll < lastScroll) {
      header.classList.remove('header--hidden');
    }
    
    lastScroll = currentScroll;
  });
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
